import React, { useMemo, useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { connect, getIn } from "formik";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Popper from "@mui/material/Popper";
import "../../../../src/pages/admin/admin.css";
import { Chip, Typography, FormHelperText, FormControl, Grid, Box, Button, Tooltip } from "@mui/material";
import CustomizedCheckbox from "../../../components/admin/common/CustomCheckBox";
import Avatar from '@mui/material/Avatar';
import { stringAvatar } from "../../../components/admin/common/Avatar";

const DropDownIcon = () => {
    return (
        <div style={{ display: "flex", alignContent: "center", marginTop: "7px", marginRight: "4px", }}>
            <img
                src={`${process.env.PUBLIC_URL}/icons/downArrowDropDown.svg`}
                alt="edit"
            ></img>
        </div>
    )
};

const BulkUpdateAutoComplete = (
    ({
        Datas,
        placeholder,
        formik,
        name,
        labelHeader,
        optionLabelName,
        optionId,
        objId = 'id',
        mode,
        autocompleteTextFieldWidth,
        showAvatar,
        showCheckBox,
        showAvatarInChip,
        temporaryMode,
        multiple,
        showBottomButton,
        buttonName,
        small,
        rightradius,
        leftradius,
        retry,
        disabled,
        row,
        ...additionalProps
    }) => {
        const [limit, setLimit] = useState(10);
        const listRef = useRef(null);
        // Store the input value without excessive re-renders
        const [inputValue, setInputValue] = useState("");
        const inputValueRef = useRef(inputValue);
        const [oldArray, setOldArray] = useState((additionalProps?.values?.length > 0) ? additionalProps?.values : []);
        const [selectAll, setSelectAll] = useState(additionalProps?.values?.length === Datas?.length);

        const handleScroll = () => {
            setLimit(prev => prev + 5);
        }

        const handleClose = () => {
            setLimit(10);
        }

        // Function to handle select all - with event prevention
        const handleSelectAll = (e) => {
            // Make sure we stop event propagation
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            // Get currently filtered data based on search input
            const filteredDatas = inputValue
                ? Datas.filter(item => item[optionLabelName].toLowerCase().includes(inputValue.toLowerCase()))
                : Datas;

            // Get current selection
            const currentSelection = additionalProps?.values || [];

            // Create a set of IDs for faster lookup
            const selectedIds = new Set(currentSelection.map(item => item[objId]));

            // Add all filtered items to selection if they're not already selected
            const newSelection = [...currentSelection];

            filteredDatas.forEach(item => {
                if (!selectedIds.has(item[objId]) &&
                    item[objId] !== "0_all" &&
                    item[objId] !== "-1_none" &&
                    item[optionLabelName] !== "ACTION_BUTTONS_ROW") {
                    newSelection.push(item);
                    selectedIds.add(item[objId]);
                }
            });

            // Update selection
            additionalProps.handleInputChange(row.id, 'skill', newSelection);
            setSelectAll(true);
            setOldArray(newSelection);

            if (additionalProps.onChangeValue) {
                additionalProps.onChangeValue.handleChangeDatasList(
                    additionalProps.onChangeValue.index,
                    newSelection,
                    additionalProps.onChangeValue.createNewDatasList
                );
            }
        };

        // Function to handle clear filtered items - with event prevention
        const handleClearFiltered = (e) => {
            // Make sure we stop event propagation
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            // If no filter or no selected items, do nothing
            const selected = additionalProps?.values;
            if (!selected || selected.length === 0) return;

            // Get the current filtered items that match the search text
            const filtered = Datas.filter(item =>
                item[optionLabelName].toLowerCase().includes(inputValue.toLowerCase())
            );

            // If no items match the filter, do nothing
            if (filtered.length === 0) return;

            // Create a set of IDs for faster lookup
            const filteredIds = new Set(filtered.map(item => item[objId]));

            // Remove matching items from selection (keep only non-filtered items)
            const newSelected = selected.filter(item => !filteredIds.has(item[objId]));

            // Update the form with the new selection
            additionalProps.handleInputChange(row.id, 'skill', newSelected);

            // Update other state as needed
            setSelectAll(false);
            setOldArray(newSelected);

            // Call any change handlers
            if (additionalProps.onChangeValue) {
                additionalProps.onChangeValue.handleChangeDatasList(
                    additionalProps.onChangeValue.index,
                    newSelected,
                    additionalProps.onChangeValue.createNewDatasList
                );
            }
        };

        const PopperMy = useMemo(
            () => (props, option) => {
                return (
                    <Popper {...props}
                        sx={{
                            "& .MuiAutocomplete-listbox": {
                                padding: "0px",
                                "& li": {
                                    height: additionalProps?.height ? additionalProps?.height : "35px !important",
                                    padding: '0px',
                                    paddingLeft: (option[optionLabelName] !== "Button") ? '5px' : '0px',
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#FFFFFF !important",
                                    marginLeft: "-1px",
                                    maxWidth: "100% !important",
                                    wordBreak: "break-all !important",
                                    whiteSpace: "normal !important",
                                },
                                "& :hover": {
                                    backgroundColor: "#FFFFFF !important"
                                },
                            },
                            '& .MuiAutocomplete-paper': {
                                marginTop: "0px",
                                marginBottom: "5px",
                                boxShadow: 'none !important',
                                border: "1px solid #E5E5E5",
                                borderRadius: "0px",
                                borderBottom: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                                borderRight: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                                borderLeft: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                                borderTop: mode === "Edit" ? "0px" : "1px solid #E5E5E5",
                                maxHeight: "275px !important",
                                overflow: "hidden !important",
                                "& .MuiAutocomplete-noOptions": {
                                    fontFamily: 'Roboto',
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#212121"
                                }
                            },
                        }} placement='bottom' />
                );
            },
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [],
        );

        const getTouchedStatus = () => {
            let touched = getIn(formik.touched, name);
            if (touched) {
                if (multiple) {
                    if (touched.length === 0) {
                        return true
                    } else {
                        return touched
                    }
                } else {
                    return touched
                }
            } else {
                return touched
            }
        }

        const selected = additionalProps?.values;
        const [tempMode, setTempMode] = useState(temporaryMode ? temporaryMode : "temp");
        function getSelected() { return selected };
        const refContainer = useRef();
        const [dimensions, setDimensions] = useState({
            width: 0,
            height: 0
        });

        const handleResize = () => {
            if (refContainer.current) {
                setDimensions({
                    width: refContainer.current.offsetWidth,
                    height: refContainer.current.offsetHeight,
                });
            }
        }

        const makeNewArray = (oldData) => {
            if (oldArray === null || oldArray.length < 1) {
                return oldData;
            } else {
                const newnew = oldArray.concat(oldData);
                const uniqueIds = [];
                const result = newnew.filter(obj => {
                    if (!uniqueIds.includes(obj[objId])) {
                        uniqueIds.push(obj[objId]);
                        return true;
                    }
                    return false;
                })
                return result;
            }
        }

        useEffect(() => {
            if (refContainer.current) {
                setDimensions({
                    width: refContainer.current.offsetWidth,
                    height: refContainer.current.offsetHeight,
                });
            }
            window.addEventListener("resize", handleResize, true);

            return () => {
                window.removeEventListener("resize", handleResize, true);
            };
        }, []);

        function changeMode() {
            if (mode !== "Add") {
                setTempMode("Edit")
            }
            if (additionalProps.onChangeValue) {
                additionalProps.onChangeValue.handleChangeDatasList(additionalProps.onChangeValue.index, selected, additionalProps.onChangeValue.createNewDatasList)
            }
        }

        const listItemStyle = useMemo(
            () => ({
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "16px",
                color: '#212121',
                paddingLeft: "6px"
            }),
            []
        );

        let styleFieldHeader = useMemo(
            () => ({
                display: "flex",
                fontSize: "12px",
                fontWeigth: 400,
                color: '#212121',
                lineHeight: "20px",
                paddingLeft: "5px",
            }),
            []
        );

        // Memoized filter function to prevent performance issues
        const filterOptions = useMemo(() => {
            return (options, params) => {
                const filter = createFilterOptions({
                    matchFrom: 'any',
                    limit: limit,
                });

                let filtered = filter(options, params);
                filtered = filtered.filter(option => option[objId] !== "0_all" && option[objId] !== "-1_none");

                // Handle selected items filtering
                let selectedFiltered = multiple ? filter((selected || []), params) : filtered;
                let uniqueOptions = filtered;

                let newOptions = uniqueOptions;

                // Add special options if needed
                if (uniqueOptions.length > 0) {
                    // Add the action buttons row as the first item
                    if (additionalProps.showselectall) {
                        newOptions.unshift({
                            [objId]: "actionButtons",
                            [optionLabelName]: "ACTION_BUTTONS_ROW"
                        });
                    }

                    if (showBottomButton) {
                        newOptions = [...newOptions, { [objId]: Datas.length + 1, [optionLabelName]: "Button" }];
                    }

                    if (additionalProps.showAllOption || additionalProps.showNoneOption) {
                        const specialOptions = [];

                        if (additionalProps.showAllOption && !selected?.some(option => option[objId] === "0_all")) {
                            specialOptions.push({ [objId]: "0_all", [optionLabelName]: "All" });
                        }

                        if (additionalProps.showNoneOption && !selected?.some(option => option[objId] === "-1_none")) {
                            specialOptions.push({ [objId]: "-1_none", [optionLabelName]: "None" });
                        }

                        newOptions = [...specialOptions, ...uniqueOptions];
                    }
                }

                setSelectAll(selected?.length === filtered?.length && filtered.length > 0);
                return newOptions;
            };
        }, [additionalProps.showAllOption, additionalProps.showNoneOption, additionalProps.showselectall,
        Datas.length, limit, multiple, objId, optionLabelName, selected, showBottomButton]);

        return (
            <div>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {labelHeader && <Typography htmlFor={name}
                        fontSize='12px'
                        fontWeight={400}
                        lineHeight='14px'
                        marginBottom={'6px'}
                        marginLeft='1px'
                        color={disabled ? "#99A0A8" : "#212121"}
                    >
                        {labelHeader}
                    </Typography>}
                    <Box
                        sx={(mode === "Edit" && tempMode === "Edit") ? {
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            paddingTop: "8px",
                            paddingLeft: "15px",
                            paddingBottom: "8px",
                            borderBottomRightRadius: 0,
                            borderBottomLeftRadius: 0,
                        } : {}}
                    >
                        {mode === "Edit" && tempMode === "Edit" && <label
                            sx={mode === "Edit" && tempMode === "Edit" && {
                                color: "#212121",
                                fontWeight: 400,
                                fontSize: "14px",
                                marginLeft: "10px",
                            }}
                        >
                            {(selected?.length < 10) ? ("0" + (selected?.length > 0 ? selected?.length : "")) : selected?.length} Selected...
                        </label>
                        }
                    </Box>
                    <Box
                        sx={(mode === "Edit" && tempMode === "Edit") ? {
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            paddingTop: "15px",
                            paddingLeft: "15px",
                            paddingBottom: "305px",
                            borderTop: 0,
                            paddingRight: "15px",
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            height: mode === "Add" ? "35px" : "344px"
                        } : {}}
                    >
                        <Autocomplete
                            ref={refContainer}
                            sx={{
                                '& .MuiAutocomplete-listbox': {
                                    scrollbarColor: 'rgb(190, 190, 190) rgb(240, 240, 240)',
                                    scrollbarWidth: 'thin',
                                },
                                "& .MuiAutocomplete-root": {
                                    "& .MuiAutocomplete-noOptions": {
                                        color: "red"
                                    }
                                },
                                "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                                    maxWidth: !retry ? (rightradius ? '280px !important' : leftradius ? '170px !important' : small ? '100px !important' : null) : retry ? (rightradius ? '380px !important' : leftradius ? '170px !important' : small ? '100px !important' : null) : null,
                                    borderRadius: (rightradius ? "0px 8px 8px 0px !important" : leftradius ? "8px 0px 0px 8px !important" : null),
                                },
                                "& .MuiAutocomplete-popupIndicatorOpen": { transform: "none", marginRight: "0px", padding: "0px", },
                            }}
                            popupIcon={additionalProps.popupIcon || <DropDownIcon />}
                            clearIcon={""}
                            noOptionsText={
                                <>
                                    {(!showBottomButton) ? "No Match Result Found !!"
                                        :
                                        <div>
                                            <div>
                                                No Match Result Found !!
                                            </div>
                                            <Button
                                                sx={{ marginLeft: '-9px', marginTop: '10px' }}
                                                onClick={() => { additionalProps.bottomButtonFunction() }}
                                            >
                                                {buttonName}
                                            </Button>
                                        </div>
                                    }
                                </>
                            }
                            autoComplete={true}
                            disabled={disabled}
                            className="ozcw-scrollbar"
                            multiple={multiple}
                            size="small"
                            id={name}
                            options={Datas}
                            value={selected}
                            inputValue={inputValue}
                            filterOptions={filterOptions}
                            disableCloseOnSelect={true}
                            renderTags={(value) => {
                                return (
                                    (mode === 'Add'
                                        ? selected?.map(
                                            (selectedvalues, i) =>
                                            (selectedvalues[optionLabelName] !== "Select All" &&
                                                selectedvalues[optionLabelName] !== "Button" &&
                                                !selectedvalues[optionLabelName]?.startsWith("Clear All") &&
                                                selectedvalues[optionLabelName] !== "ACTION_BUTTONS_ROW" &&
                                                <div key={i} >
                                                    <Chip
                                                        avatar={showAvatarInChip ? <Avatar
                                                            style={{ width: "24px", height: "24px", fontSize: "14px", color: "#212121", marginLeft: "4px" }}
                                                            {...stringAvatar(selectedvalues[optionLabelName])}>
                                                        </Avatar> : null}
                                                        key={selectedvalues[optionLabelName] + i} label={selectedvalues[optionLabelName]} className="oz-customAutoComplete-chip-style" />
                                                </div>
                                            )
                                        )
                                        :
                                        (<div style={{
                                            display: "flex",
                                            alignItems: 'center',
                                            alignContent: "center",
                                        }}>
                                            <Typography sx={styleFieldHeader}>
                                                {selected?.map(
                                                    (selectedvalues, index) =>
                                                    (selectedvalues[optionLabelName] !== "ACTION_BUTTONS_ROW" &&
                                                        index < 3 && ((selectedvalues[optionLabelName] + (((selected?.length - 1) > index) ? ", " : ""))))
                                                )}
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                color: "#212121",
                                                paddingRight: '5px',
                                                paddingLeft: "5px"
                                            }}>
                                                {(selected?.length > 3) ? "..." : ""}
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                color: "#99A0A8",
                                            }}>
                                                {(selected?.length > 3) ? (("+" + (selected?.length - 3))) : ""}
                                            </Typography>
                                        </div>))
                                )
                            }}
                            role="listbox"
                            onChange={(e, value, reason, options) => {
                                if (multiple) {
                                    // Skip the ACTION_BUTTONS_ROW from being selected
                                    const filteredValue = value.filter(option => option[optionLabelName] !== "ACTION_BUTTONS_ROW");

                                    if (filteredValue.find(option => option[objId] === "0_all" || option[objId] === "-1_none")) {
                                        // If "All" or "None" is selected, clear other selections
                                        const singleOption = options?.option;
                                        additionalProps.handleInputChange(row.id, 'skill', [singleOption]);
                                        if (additionalProps.onChangeValue) {
                                            additionalProps.onChangeValue.handleChangeDatasList(additionalProps.onChangeValue.index, [singleOption], additionalProps.onChangeValue.createNewDatasList);
                                        }
                                    }
                                    else if (filteredValue.find((option) => option[objId] === 0)) {
                                        // Handle Select All option differently than the old implementation
                                        // We want to add the currently visible/filtered items to the existing selection
                                        const filteredDatas = Datas.filter((item) => {
                                            if (!inputValue) return true;
                                            return String(item[optionLabelName]).toLowerCase().includes(inputValue.toLowerCase());
                                        });

                                        // Create a set of IDs for faster lookup
                                        const selectedIds = new Set(selected?.map(item => item[objId]) || []);

                                        // Add all filtered items to selection if they're not already selected
                                        const newSelection = [...(selected || [])];

                                        filteredDatas.forEach(item => {
                                            if (!selectedIds.has(item[objId]) &&
                                                item[objId] !== "0_all" &&
                                                item[objId] !== "-1_none" &&
                                                item[optionLabelName] !== "ACTION_BUTTONS_ROW" &&
                                                item[objId] !== 0) {
                                                newSelection.push(item);
                                                selectedIds.add(item[objId]);
                                            }
                                        });

                                        // If all items are already selected, then clicking "Select All" should deselect all
                                        if (selectedIds.size >= filteredDatas.length && selectedIds.size > 0) {
                                            additionalProps.handleInputChange(row.id, 'skill', []);
                                            setOldArray([]);
                                            if (additionalProps.onChangeValue) {
                                                additionalProps.onChangeValue.handleChangeDatasList(
                                                    additionalProps.onChangeValue.index,
                                                    [],
                                                    "removeOption",
                                                    newSelection
                                                )
                                            }
                                        } else {
                                            additionalProps.handleInputChange(row.id, 'skill', newSelection);
                                            setOldArray(newSelection);
                                            if (additionalProps.onChangeValue) {
                                                additionalProps.onChangeValue.handleChangeDatasList(
                                                    additionalProps.onChangeValue.index,
                                                    newSelection,
                                                    additionalProps.onChangeValue.createNewDatasList
                                                )
                                            }
                                        }
                                    } else {
                                        // Skip Clear All option from being added to selection
                                        const hasClearFiltered = filteredValue.some(option =>
                                            option[optionLabelName] && option[optionLabelName].startsWith("Clear All")
                                        );

                                        if (hasClearFiltered) {
                                            // Don't update selection if Clear All was clicked
                                            // It will be handled separately
                                            return;
                                        }

                                        if (additionalProps.onChangeValue) {
                                            additionalProps.onChangeValue.handleChangeDatasList(additionalProps.onChangeValue.index, filteredValue, additionalProps.onChangeValue.createNewDatasList)
                                        }
                                        additionalProps.handleInputChange(row.id, 'skill', filteredValue);
                                    }
                                } else {
                                    if (!(value[objId] === (Datas.length + 1)) && value[optionLabelName] !== "ACTION_BUTTONS_ROW") {
                                        additionalProps.handleInputChange(row.id, 'skill', value);
                                    }
                                }
                                if (reason === "removeOption") {
                                    if (additionalProps.onChangeValue) {
                                        additionalProps.onChangeValue.handleChangeDatasList(additionalProps.onChangeValue.index, [], reason, [options.option])
                                    }
                                }
                            }}
                            getOptionLabel={(option) => option[optionLabelName]}
                            ListboxProps={{
                                ref: listRef,
                                onScroll: handleScroll,
                                sx: {
                                    maxHeight: "280px",
                                }
                            }}
                            onClose={handleClose}
                            PopperComponent={PopperMy}
                            renderOption={(props, option, { selected }) => {
                                // Render the action buttons row
                                if (option[optionLabelName] === "ACTION_BUTTONS_ROW") {
                                    return (
                                        <li {...props}
                                            style={{
                                                padding: 0,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                borderBottom: '1px solid #E5E5E5',
                                                height: 'auto !important'
                                            }}
                                            // These event handlers are critical to prevent the dropdown from closing
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.preventDefault()}
                                        >
                                            <Button
                                                sx={{
                                                    textTransform: 'none',
                                                    flex: 1,
                                                    justifyContent: 'center',
                                                    fontFamily: 'Roboto',
                                                    fontWeight: 400,
                                                    color: '#3D8BF8',
                                                    borderRight: '1px solid #E5E5E5',
                                                    minWidth: 'auto',
                                                    borderRadius: 0
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleSelectAll(e);
                                                    return false;
                                                }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            >
                                                Select All
                                            </Button>
                                            <Button
                                                style={{
                                                    textTransform: 'none',
                                                    flex: 1,
                                                    justifyContent: 'center',
                                                    fontFamily: 'Roboto',
                                                    fontWeight: 400,
                                                    color: '#3D8BF8',
                                                    minWidth: 'auto',
                                                    borderRadius: 0
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleClearFiltered(e);
                                                    return false;
                                                }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            >
                                                {"Clear All"}
                                            </Button>
                                        </li>
                                    );
                                }

                                // Skip rendering any special options since we handle them in the header now
                                if (option[optionLabelName] === "Select All" ||
                                    option[optionLabelName]?.startsWith("Clear All")) {
                                    return null;
                                }

                                return (
                                    <Tooltip title={option[optionLabelName]}>
                                        <div key={option[optionLabelName] + option[objId]}
                                            onClick={() => {
                                                if (option[optionLabelName] === getSelected()?.name) {
                                                    additionalProps.handleInputChange(row.id, 'skill', []);
                                                }
                                            }} style={{
                                                bgcolor: "#FFFFFF",
                                                position: option[optionLabelName] === "Button" ? 'fixed' : '',
                                                bottom: option[optionLabelName] === "Button" ? '-25px' : '',
                                            }}>
                                            <li {...props} style={{ height: option[optionLabelName] === "Button" ? "32px" : "36px", }} key={option[optionLabelName] + option[objId]}>
                                                {(showCheckBox && (option[optionLabelName] !== "Button")) && <CustomizedCheckbox
                                                    checked={(option[objId] === 0) ? selectAll : selected}
                                                />}
                                                {(showAvatar && (option[optionLabelName] !== "Button")) && (option[optionLabelName] !== "Select All") &&
                                                    <Avatar style={{ width: "24px", height: "24px", fontSize: "14px", color: "#212121", marginLeft: "4px" }} {...stringAvatar(option[optionLabelName])}></Avatar>
                                                }
                                                {option[optionLabelName] === "Button" ?
                                                    <Button sx={{
                                                        fontSize: "14px",
                                                        lineHeight: "16px",
                                                        color: "#3D8BF8",
                                                        fontWeight: '400',
                                                        bgcolor: "#FFFFFF",
                                                        border: "1px solid #E5E5E5",
                                                        borderTopLeftRadius: "0px",
                                                        borderTopRightRadius: "0px",
                                                        marginLeft: "-5px",
                                                        width: String(dimensions.width) + "px !important",
                                                        maxWidth: "1000px !important",
                                                        marginTop: "-3px",
                                                        '&:hover': {
                                                            backgroundColor: '#FFFFFF !important',
                                                        }
                                                    }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            additionalProps.bottomButtonFunction();
                                                        }}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                    >
                                                        {buttonName}
                                                    </Button>
                                                    :
                                                    <Typography sx={listItemStyle}>{option[optionLabelName]}</Typography>
                                                }
                                            </li>
                                            {
                                                mode === "Edit" && tempMode === "Edit" && getSelected()?.length > 0 && getSelected()?.length < Datas?.length && props["data-option-index"] === getSelected()?.length &&
                                                <div style={{
                                                    border: "1px solid #E6E5E6",
                                                    height: "5px !important",
                                                    marginLeft: "5px"
                                                }}>
                                                </div>
                                            }
                                        </div>
                                    </Tooltip>
                                )
                            }}
                            onInputChange={(e, newValue, reason) => {
                                // Optimize input handling
                                if (reason === 'input') {
                                    setInputValue(newValue);
                                    inputValueRef.current = newValue;
                                }
                            }}
                            renderInput={(params) => (
                                ((tempMode !== 'temp') || (mode === 'Add')) && <div>
                                    <FormControl component="fieldset" fullWidth>
                                        <TextField
                                            onClick={changeMode}
                                            sx={{
                                                minWidth: "322px",
                                                paddingRight: tempMode === "temp" ? "" : "10px",
                                                '& .MuiOutlinedInput-root': {
                                                    minHeight: additionalProps?.height ? additionalProps?.height : "44px",
                                                    fontSize: "14px",
                                                    color: params.inputProps.value === "" ? "#99A0A8" : "#212121",
                                                    borderRadius: '8px',
                                                },
                                                '& .MuiAutocomplete-input': {
                                                    display: (tempMode === 'temp') && (mode !== 'Add') ? 'none' : 'block'
                                                },
                                                "& .MuiOutlinedInput-root.Mui-focused": {
                                                    "& > fieldset": mode === "Add" ? {
                                                        borderBottomLeftRadius: "0px", borderBottomRightRadius: '0px', border: "1px solid #E5E5E5"
                                                    } : { border: "1px solid #E5E5E5" },
                                                },
                                                "& .MuiOutlinedInput-root:hover": {
                                                    "& > fieldset": {
                                                        border: "1px solid #E5E5E5"
                                                    }
                                                }
                                            }}
                                            {...params} placeholder={(tempMode !== 'temp') || (mode === 'Add') ? placeholder : ""} />
                                    </FormControl>
                                </div>
                            )}
                            isOptionEqualToValue={(option, value) => option[optionId || optionLabelName] === value[optionId || optionLabelName]}
                            {...additionalProps}
                        />
                    </Box>
                </Grid>
                {
                    mode !== 'Add' &&
                    (tempMode !== 'Edit') &&
                    <Grid item xs={12}>
                        <TextField
                            onClick={changeMode}
                            sx={{
                                minWidth: "300px",
                                paddingRight: tempMode === "temp" ? "" : "10px",
                                '& .MuiOutlinedInput-root': {
                                    minHeight: "35px",
                                    fontSize: "14px",
                                    borderRadius: '8px',
                                    height: additionalProps?.height ? additionalProps?.height : "44px",
                                    width: autocompleteTextFieldWidth || ""
                                },
                                '& .MuiAutocomplete-input': {
                                    display: (tempMode === 'temp') && (mode !== 'Add') ? 'none' : 'block'
                                },
                                "& .MuiOutlinedInput-root.Mui-focused": {
                                    "& > fieldset": mode === "Add" ? {
                                        borderBottomLeftRadius: "0px", borderBottomRightRadius: '0px', border: "1px solid #E5E5E5"
                                    } : { border: "1px solid #E5E5E5" },
                                },
                                "& .MuiOutlinedInput-root:hover": {
                                    "& > fieldset": {
                                        border: "1px solid #E5E5E5"
                                    }
                                },
                                "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                                    textOverflow: "ellipsis"
                                }
                            }}
                            value={selected?.filter(item => item[optionLabelName] !== "ACTION_BUTTONS_ROW").map((item) => { return item[optionLabelName] })}
                            placeholder={placeholder} />
                    </Grid>
                }
            </div >
        );
    }
);
export default BulkUpdateAutoComplete;